import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal, viewChild } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Tooltip, TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'info-tooltip',
    templateUrl: './info-tooltip.component.html',
    styleUrls: ['./info-tooltip.component.scss'],
    standalone: true,
    imports: [TooltipModule, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoTooltipComponent implements OnInit {
    private translateService = inject(TranslateService);

    id = input.required<string>();
    text = input.required<string>();

    position = input<string>('top');
    iconClass = input<string>('fa-regular fa-circle-question');
    tooltipDisabled = input<boolean>(false);
    tooltipEscape = input<boolean>(false); //Set to false to support html tags in the content.
    ellipsisCharacterLength = input<number>(0);

    readonly tooltipEl = viewChild<Tooltip>(Tooltip);
    styleClass = signal<string>('');

    ngOnInit(): void {
        const text = this.translateService.instant(this.text()) || '';

        if (text.length > 500) {
            this.styleClass.set('xl-info-tooltip');
        } else if (text.length > 150) {
            this.styleClass.set('lg-info-tooltip');
        }
        if (this.ellipsisCharacterLength() > 0) {
            this.displayEllipsisOnTooltip();
        }
    }

    activateTooltip(event: Event) {
        if (this.tooltipDisabled()) {
            return;
        }
        this.tooltipEl()?.activate();
        event.stopPropagation();
    }

    deactivateTooltip(event: Event) {
        this.tooltipEl()?.deactivate();
        event.stopPropagation();
    }

    private displayEllipsisOnTooltip() {
        const text = this.translateService.instant(this.text()) || '';

        if (text.length > this.ellipsisCharacterLength()) {
            this.styleClass.set('ellipsis-tooltip');
        }
    }
}
